<div>
    @if (checkPermissions() && originalText && originalText.trim() !== "") {
        <span class="translate-link" (click)="toggleText()">{{ buttonLabel }}</span>
    }
</div>
